export const ROOM_COMMENT_PER_PAGE = 5;
